
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeleteConfirmationDialogComponent } from './delete-confirmation-dialog.component';
import { CardModule } from 'libraries/ui_card/card.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        BtnModule,
        NotificationModule,
    ],
    declarations: [
        DeleteConfirmationDialogComponent,
    ],
    exports: [
        DeleteConfirmationDialogComponent,
    ],
    entryComponents: [
        DeleteConfirmationDialogComponent,
    ],
})
export class DeleteConfirmationDialogModule {}